import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './services/api'
import { loadAMap } from './config/map'
import { initTheme } from './utils/theme'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant'
import 'vant/lib/index.css'
// 主题变量与组件覆盖必须放在 Element / Vant 样式之后，才能覆盖默认蓝色主题
import './assets/styles/global.css'
import './assets/iconfont/iconfont.css'

Vue.use(ElementUI)
Vue.use(Vant)

Vue.prototype.$api = api

Vue.config.productionTip = false

// 启动即应用已保存的主题，避免首屏闪烁默认色
initTheme()

loadAMap()
  .then(() => {
    console.log('高德地图加载成功')
  })
  .catch(err => {
    console.error('高德地图加载失败:', err)
  })
  .finally(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })
